const customData = [
  { name: "万州区", value: 5004638 },
  { name: "涪陵区", value: 5004640 },
  { name: "渝中区", value: 5004641 },
  { name: "大渡口区", value: 5004642 },
  { name: "江北区", value: 5004643 },
  { name: "沙坪坝区", value: 5004644 },
  { name: "九龙坡区", value: 5004645 },
  { name: "南岸区", value: 5004646 },
  { name: "北碚区", value: 5004647 },
  { name: "綦江区", value: 5004655 },
  { name: "大足区", value: 5004656 },
  { name: "渝北区", value: 5004648 },
  { name: "巴南区", value: 5004649 },
  { name: "黔江区", value: 5004639 },
  { name: "长寿区", value: 5004650 },
  { name: "江津区", value: 5004651 },
  { name: "合川区", value: 5004652 },
  { name: "永川区", value: 5004653 },
  { name: "南川区", value: 5004654 },
  { name: "璧山区", value: 5004657 },
  { name: "铜梁区", value: 5004658 },
  { name: "潼南区", value: 5004659 },
  { name: "荣昌区", value: 5004660 },
  { name: "开州区", value: 5004661 },
  { name: "梁平区", value: 5004662 },
  { name: "武隆区", value: 5004663 },
  { name: "城口县", value: 5004664 },
  { name: "丰都县", value: 5004665 },
  { name: "垫江县", value: 5004666 },
  { name: "忠县", value: 5004667 },
  { name: "云阳县", value: 5004668 },
  { name: "奉节县", value: 5004669 },
  { name: "巫山县", value: 5004670 },
  { name: "巫溪县", value: 5004671 },
  { name: "石柱土家族自治县", value: 5004672 },
  { name: "秀山土家族苗族自治县", value: 5004673 },
  { name: "酉阳土家族苗族自治县", value: 5004674 },
  { name: "彭水苗族土家族自治县", value: 5004675 },
];
// ['万州', '涪陵', '渝中', '大渡口', '江北', '沙坪坝', '九龙坡', '南岸', '北碚', '綦江', '大足', '渝北', '巴南', '黔江', '长寿', '江津', '合川', '永川', '南川', '璧山', '铜梁', '潼南', '荣昌', '开州', '梁平', '武隆', '城口', '丰都', '垫江', '忠县', '云阳', '奉节', '巫山', '巫溪', '石柱', '秀山', '酉阳', '彭水']

document.addEventListener("DOMContentLoaded", () => {
  const mapDom = document.getElementById("map");

  if (!mapDom) {
    return;
  }

  const echartInstance = echarts.init(mapDom);

  echartInstance.showLoading();

  getGeojsonFeature((geoJson) => {
    // console.log( "cq > ", JSON.stringify( geoJson.features.map((i) => ({ name: i.properties.name, value: 0 })) ) );

    echarts.registerMap("cq", geoJson);

    echartInstance.setOption({
      series: [
        {
          type: "map",
          map: "cq",
          roam: true,
          aspectScale: 1,
          label: {
            show: true,
          },
          data: customData,
        },
      ],
    });

    echartInstance.hideLoading();
  });

  echartInstance.on("click", function (params) {
    console.log(params);
    alert("看 console.log");
  });
});

function getGeojsonFeature(callback: (geoJson: any) => void) {
  const xhr = new XMLHttpRequest();
  xhr.open(
    "GET",
    // "../../assets/geojson/cqqiaolian/chongqing-center.json",
    "../../assets/geojson/cqqiaolian/chongqing.json",
    true
  );
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      const geojson = JSON.parse(xhr.responseText);

      callback(geojson);
    }
  };

  xhr.send();
}
